<template>
  <div>

    <!-- BEGIN #accordion -->
    <div v-for="(item, index)  in receivers" :key="index" id="accordion" class="accordion rounded-top overflow-hidden">

      <!-- BEGIN b-card -->
      <b-card class="border-0 rounded-1" no-body>
        <b-card-header @click="fetchMessage(item.id)" header-tag="header"
          class="card-header pointer-cursor px-3 py-10px d-flex align-items-center" v-b-toggle="'accordion' + index">
          <div class="d-flex mb-2">
            <b>{{ item.task.user.name }}</b> &nbsp;и&nbsp; <b>{{ item.user.name }}</b>
          </div>
        </b-card-header>
        <b-collapse :id="`accordion` + index" visible accordion="my-accordion">
          <div>
            <!-- begin widget-chat -->
            <div class="widget-chat rounded mt-3">
              <!-- begin widget-chat-body -->
              <div class="widget-chat-body" data-scrollbar="true" data-height="235px">
                <!--<div class="text-center text-gray-500 m-3 fw-bold">Today</div>-->
                <div class="widget-chat-item with-media" :class="(item.user.id == user.id) ? 'end' : 'start'"
                  v-for="(item, index)  in messages" :key="index">
                  <div class="widget-chat-media">
                    <img onerror="javascript:this.src='/images/avatar/user.png'" alt=""
                      :src="`/images/avatar/` + item.user.avatar" class="user-avatar" width="50" height="50" />
                  </div>
                  <div class="widget-chat-info">
                    <div class="widget-chat-info-container">
                      <div v-if="item.user.id == messages[0].user.id" class="widget-chat-name text-indigo"> {{
                        item.user.name
                      }} <div class="badge bg-indigo-400">{{
  item.user.rating }}</div>
                        <div class="badge bg-indigo-100  ms-2"> {{ item.user.balance_buy }}</div>
                      </div>
                      <div v-else class="widget-chat-name text-pink"> {{ item.user.name
                      }} <div class="badge bg-pink-400">{{
  item.user.rating }}</div>
                        <div class="badge bg-pink-100 ms-2"> {{ item.user.balance_buy }}</div>
                      </div>
                      <div class="widget-chat-message pre-formatted">
                        <div v-html="addTagsToLinks(item.message)"></div>
                        <div class="d-flex flex-wrap">
                          <div class="m-2" v-for="(image, index)  in item.images" :key=index>
                            <!-- BEGIN image -->
                            <img class="imageWrapper" :src="`/images/screen/` + image.name" alt=""
                              @click="open(`/images/screen/` + image.name)">
                            <!-- END image -->
                          </div>
                        </div>
                      </div>
                      <div class="widget-chat-time">{{ item.created_at }} </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end widget-chat-body -->

              <!-- begin widget-input -->
              <div class="widget-input">
                <form action="" method="POST" name="">
                  <div class="d-flex flex-column">
                    <div class="d-flex justify-content-start ms-2">
                      <div v-for="(image, index)  in images" :key=index class="imageWrapper me-1 mt-2 mb-2"
                        :style="{ 'background-image': `url(${image})` }" style="width: 100px;height: 100px;">
                        <div class="d-flex justify-content-end">
                          <a @click="removeImage(index)" class="btn  btn-icon btn-circle btn-danger">
                            <i class="fa fa-times"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="m-2">
                      <validation-observer ref="form">
                        <validation-provider #default="{ errors }" name="message" rules="required|min:1|max:5120"
                          vid="message">
                          <textarea v-model="message" class="form-control" rows="6"></textarea>
                          <small v-show="!errors[0]">Опишите подробно вашу проблему.</small>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </validation-observer>
                    </div>

                    <div class="d-flex justify-content-between ms-2 me-2 mb-2">
                      <div class="btn btn-info w-100px me-2"
                        @click="$router.push(`/task/${item.task_id}/review`).catch(() => { });">
                        <i v-show="loading" class="fas fa-circle-notch fa-spin"></i>
                        <span v-show="!loading">Задание</span>
                      </div>
                      <div class="d-flex justify-content-between me-2">
                        <div class="me-2">
                          <select v-model="status" class="form-select ">
                            <option v-for="(status, index)  in statuses" :key=index :value="status.name">
                              {{ status.desc }}
                            </option>
                          </select>
                        </div>
                        <div class="btn btn-white w-100px" @click="statChange(item.id)"> <i v-show="loading"
                            class="fas fa-circle-notch fa-spin"></i>
                          <span v-show="!loading"> Изменить</span>
                        </div>
                      </div>


                      <div class="btn btn-primary w-100px" @click="messageSend(item.id)"> <i v-show="loading"
                          class="fas fa-circle-notch fa-spin"></i>
                        <span v-show="!loading"> Ответить</span>
                      </div>

                    </div>
                  </div>
                </form>
              </div>
              <!-- end widget-input -->
            </div>
            <!-- end widget-chat -->
          </div>
        </b-collapse>
      </b-card>
      <!-- END b-card -->
    </div>
    <!-- END #accordion -->


  </div>
</template>

<script>
import HTTP from "../http";
import {show_error} from "../message";
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required} from 'vee-validate/dist/rules';
extend('required', required);

export default {

  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      loading: false,
      message: "",
      previewImage: null,
      images: [],
      files: [],
      user: {},
      messages: [],
      receivers: [],
      status: "REJECTED",
      statuses: [
        {name: "REJECTED", desc: 'Отказать (Заказчик прав)'},
        {name: "ACCEPTED", desc: 'Принять( Исполнитель прав)'},
        {name: "DECLINED", desc: 'Отправить на доработку'},
        {name: "CANCELED", desc: 'Отменить, задание невыполнимо'},
      ]
    }
  },

  mounted() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.fetchData()
  },

  methods: {
    isUrlValid(str) {
      let url;
      try {
        url = new URL(str);
      } catch (_) {
        return false;
      }
      return url.protocol === "http:" || url.protocol === "https:";
    },
    stringToUrl(str) {
      return this.isUrlValid(str) ? `<a target="_blank" href="${str}">${str}</a>` : str
    },
    addTagsToLinks(str) {
      str = str.replace(/(<([^>]+)>)/ig, '')
      let lines = str.split(/\r?\n/)
      lines = lines.map(x => x.split(' ').reduce((accumulator, currentValue) => accumulator + ' ' + this.stringToUrl(currentValue), ''))

      return lines.reduce((accumulator, currentValue) => accumulator + '\r\n' + this.stringToUrl(currentValue))
    },
    checkForm() {
      this.$refs.form.validate().then(success => {
        if (!success) {
          return;
        }
        this.messageSend()
      })
    },

    fetchData() {
      this.loading = true;
      this.$insProgress.start();
      HTTP()
        .get("/arbitrage")
        .then((resp) => {
          console.log('resp', resp)
          this.receivers = resp.data
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
          setTimeout(() => {this.fetchMessage(this.receivers[0].id)}, 500);
        });
    },

    fetchMessage(id) {

      this.loading = true;
      this.$insProgress.start();
      HTTP()
        .get("/arbitrage/" + id)
        .then((resp) => {
          console.log('resp', resp)
          this.messages = resp.data
          this.messages = this.messages.sort((a, b) => a.id - b.id);
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
        });
    },

    sleep(ms) {
      new Promise(resolve => setTimeout(resolve, ms))
    },

    messageSend(id) {
      this.loading = true;
      this.$insProgress.start();
      HTTP()
        .post(`/arbitrage`, {id: id, message: this.message})
        .then(async () => {
          this.message = ''
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        })
        .finally(async () => {
          setTimeout(() => {this.fetchMessage(id)}, 500);
          this.loading = false;
          this.$insProgress.finish();
        });
    },

    statChange(id) {
      this.loading = true;
      this.$insProgress.start();
      HTTP()
        .put(`/arbitrage/` + id, {id: id, status: this.status})
        .then(async () => {
          this.message = ''

        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        })
        .finally(async () => {
          setTimeout(() => {this.fetchData()}, 500);
          this.loading = false;
          this.$insProgress.finish();

        });
    },
  }
}
</script>


